module.exports = __webpack_public_path__ + "static/media/blankWeekView.301b7c93.svg";